module.exports = __webpack_public_path__ + "img/guide_5_5.161f03d2.svg";